import { render, staticRenderFns } from "./TimeRegistrationForm.vue?vue&type=template&id=3782bee0&"
import script from "./TimeRegistrationForm.vue?vue&type=script&lang=ts&"
export * from "./TimeRegistrationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports